<template>
  <v-layout row justify-center id="meetingAttendeeDialog">
    <v-dialog v-model="dialog" persistent max-width="700" max-height="1140">
      <v-card>
        <v-card-title class="headline">
          <div class="page-header-left" style="width:100%; display:flex; align-items: center; justify-content: space-between; margin-top:-5px; margin-bottom:-10px;">
            <!-- <img v-bind:src="computePageHeaderIcon" style="margin-bottom:-8px;" alt="title bar"> -->
            <h4 class="popup-title" style="padding: 0;">{{ $t('page.meeting-control.detail.detail') }}</h4>
            <img @click="close" src="/static/icon-contents/close-1.svg" style="width: 16px; height: 16px; cursor: pointer;" >
            
          </div>
        </v-card-title>
        <div class="divider-bar-thin"></div>
        <div style="margin-bottom:5px;"></div>

        <v-card-text class="popup-card-padding">
          <v-card>
            <v-card-text class="popup-card-padding">
                <v-layout wrap slot="widget-content" v-if="attendeeDetailInfo !== null">
                  <v-flex xs12>
                    <v-layout row justify-center align-center class="info-row-small">
                      <v-flex xs4 md4 subheading>
                        <v-layout row justify-center>
                          <v-flex xs1 md1 style="align-self: center;"><div id="circle"></div></v-flex>
                          <v-flex xs11 md11>
                            <span class="attendee-detail-info-title">{{ $t('page.meeting-control.detail.name')}}&nbsp;:
                            </span>
                          </v-flex>
                        </v-layout>
                        <!-- <v-icon color="pink">{{ attendeeInfo.type === 'person' ? 'mdi-account' : 'mdi-desktop-mac' }}</v-icon> -->
                      </v-flex>
                      <v-flex xs8 md8>
                        <span class="attendee-detail-info-content">{{ attendeeInfo.name }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider ></v-divider>
                    <v-layout row justify-center align-center class="info-row-small">
                      <v-flex xs4 md4 subheading>
                        <v-layout row justify-center>
                          <v-flex xs1 md1 style="align-self: center;"><div id="circle"></div></v-flex>
                          <v-flex xs11 md11>
                            <span class="attendee-detail-info-title">{{ $t('page.meeting-control.detail.id')}}&nbsp;:
                            </span>
                          </v-flex>
                        </v-layout>
                        <!-- <v-icon color="pink">mdi-account-key</v-icon> -->
                      </v-flex>
                      <v-flex xs8 md8>
                        <span class="attendee-detail-info-content">
                          {{ attendeeDetailInfo.remoteParty }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider ></v-divider>
                    <v-layout row justify-center align-center class="info-row-small">
                      <v-flex xs4 md4 subheading>
                        <v-layout row justify-center>
                          <v-flex xs1 md1 style="align-self: center;"><div id="circle"></div></v-flex>
                          <v-flex xs11 md11>
                            <span class="attendee-detail-info-title">{{ $t('page.meeting-control.detail.type-subtype')}}&nbsp;:
                            </span>
                          </v-flex>
                        </v-layout>
                        <!-- <v-icon color="pink">mdi-help-network</v-icon> -->
                      </v-flex>
                      <v-flex xs8 md8>
                        <span class="attendee-detail-info-content">
                          {{ `${attendeeDetailInfo.type}${attendeeDetailInfo.subType ? ' / ' + attendeeDetailInfo.subType : ''}` }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider ></v-divider>
                    <v-layout row justify-center align-center class="info-row-small">
                      <v-flex xs4 md4 subheading>
                        <v-layout row justify-center>
                          <v-flex xs1 md1 style="align-self: center;"><div id="circle"></div></v-flex>
                          <v-flex xs11 md11>
                            <span class="attendee-detail-info-title">{{ $t('page.meeting-control.detail.direction')}}&nbsp;:
                        </span>
                          </v-flex>
                        </v-layout>
                        <!-- <v-icon color="pink">mdi-exit-to-app</v-icon> -->
                      </v-flex>
                      <v-flex xs8 md8>
                        <span class="attendee-detail-info-content">
                          {{ attendeeDetailInfo.direction }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider ></v-divider>
                    <v-layout row justify-center align-center class="info-row-small">
                      <v-flex xs4 md4 subheading>
                        <v-layout row justify-center>
                          <v-flex xs1 md1 style="align-self: center;"><div id="circle"></div></v-flex>
                          <v-flex xs11 md11>
                            <span class="attendee-detail-info-title">{{ $t('page.meeting-control.detail.duration-seconds')}}&nbsp;:
                            </span>
                          </v-flex>
                        </v-layout>
                        <!-- <v-icon color="pink">mdi-clock-start</v-icon> -->
                      </v-flex>
                      <v-flex xs8 md8>
                        <span class="attendee-detail-info-content">
                          {{ secondsToTimeString(attendeeDetailInfo.status.durationSeconds) }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider ></v-divider>
                    <v-layout row justify-center align-center class="info-row-small">
                      <v-flex xs4 md4 subheading>
                        <v-layout row justify-center>
                          <v-flex xs1 md1 style="align-self: center;"><div id="circle"></div></v-flex>
                          <v-flex xs11 md11>
                            <span class="attendee-detail-info-title">{{ $t('page.meeting-control.detail.layout')}}&nbsp;:
                            </span>
                          </v-flex>
                        </v-layout>
                        <!-- <v-icon color="pink">mdi-page-layout-body</v-icon> -->
                      </v-flex>
                      <v-flex xs8 md8 style="margin-top:-38px; margin-bottom:-25px;"> 
                        <v-select
                          height="36px"
                          :items="layoutList"
                          v-model="layoutValue"
                          @change="layoutChange(attendeeInfo.callLegId, layoutValue)"
                          color="pink"
                          hide-details
                          single-line
                          style="padding-top:0px !important;"
                        >
                          <template v-slot:selection="{ item }">
                            <img v-bind:src="item.url" style="width:16px;height:16px;" :alt="item.text">&nbsp;
                            <span>{{ item.text }}</span>
                          </template>
                          <template slot="item" slot-scope="data">
                            <template>
                              <img v-bind:src="data.item.url" style="width:16px;height:16px;" :alt="data.item.text">&nbsp;
                              <span>{{ data.item.text }}</span>
                            </template>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-for="(item, index) in rxTxItems" :key="'rxtx-'+index">
                    <v-divider ></v-divider>
                    <v-layout row wrap justify-center align-center class="info-row-small">
                      <v-flex xs4 md4 subheading>
                        <v-layout row justify-center>
                          <v-flex xs1 md1 style="align-self: center;"><div id="circle"></div></v-flex>
                          <v-flex xs11 md11>
                            <span class="attendee-detail-info-title">{{ $t(item.title)}}&nbsp;
                            </span>
                          </v-flex>
                        </v-layout>
                        <!-- <v-icon color="pink">{{ item.icon }}</v-icon> -->
                      </v-flex>
                      <v-flex xs8 md8>
                      </v-flex>
                      <v-flex xs12 md12 v-for="(itemData, index) in item.datas" :key="item.type + '-' +index">
                        <v-layout>
                          <v-flex xs7 md5 subheading>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <span class="attendee-detail-info-sub-title">{{ $t(itemData.title)}}&nbsp;-
                            </span>
                          </v-flex>
                          <v-flex xs5 md7>
                            <span class="attendee-detail-info-sub-content">
                              {{ itemData.value }}
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      
                    </v-layout>
                  </v-flex>
                  <!-- <v-flex xs12>
                    <v-divider ></v-divider>
                    <v-expansion-panel
                      v-model="panelRxTx"
                      expand
                    >
                      <v-expansion-panel-content
                          v-for="(item,i) in rxTxItems"
                          :key="i"
                        >
                        <template v-slot:header>
                          <div>{{ $t(item.title) }}</div>
                        </template>
                        <v-card>
                          <v-card-text>consequat.</v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex> -->
                </v-layout>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="closeBtnColor" dark @click="close()">{{ $t('dialog.info.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import VWidget from '@/components/VWidget';
import Util from '@/util';

export default {
  components: {
    VWidget
  },
  props: [
    'attendeeInfo',
    'attendeeDetailInfo',
    'layoutChange',
    'refreshDetailData',
    'layoutList',
    'dialog',
    'closeDialog'
  ],
  data () {
    return {
      loading: true,
      layoutValue: null,
      rxTxItems: [
        {
          icon: 'mdi-gauge',
          type: 'rxAudio',
          title: 'page.meeting-control.detail.rx-audio.rx-audio',
          datas: [
            {
              title: 'page.meeting-control.detail.rx-audio.packet-loss-per',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.rx-audio.jitter',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.rx-audio.bit-rate',
              value: null,
            }
          ]
        },
        {
          icon: 'mdi-gauge',
          type: 'txAudio',
          title: 'page.meeting-control.detail.tx-audio.tx-audio',
          datas: [
            {
              title: 'page.meeting-control.detail.tx-audio.packet-loss-per',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.tx-audio.jitter',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.tx-audio.bit-rate',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.tx-audio.round-trip-time',
              value: null,
            }
          ]
        },
        {
          icon: 'mdi-gauge',
          type: 'rxVideo',
          title: 'page.meeting-control.detail.rx-video.rx-video',
          datas: [
            {
              title: 'page.meeting-control.detail.rx-video.packet-loss-per',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.rx-video.jitter',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.rx-video.bit-rate',
              value: null,
            }
          ]
        },
        {
          icon: 'mdi-gauge',
          type: 'txVideo',
          title: 'page.meeting-control.detail.tx-video.tx-video',
          datas: [
            {
              title: 'page.meeting-control.detail.tx-video.packet-loss-per',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.tx-video.jitter',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.tx-video.bit-rate',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.tx-video.width',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.tx-video.height',
              value: null,
            },
            {
              title: 'page.meeting-control.detail.tx-video.frame-rate',
              value: null,
            }
          ]
        }
      ]
    };
  },
  computed: {
    computePageHeaderIcon () {
      return '/static/page_header.png';
    }  
  },
  watch: {
    dialog (val) {
      if (val) {
        this.layoutValue = this.attendeeDetailInfo.status.layout;
        // Rx Tx Data Setting
        this.setDatas();
        this.timer = setInterval(async () => {
          let now = new Date();
          // Get data
          await this.refreshDetailData(this.attendeeInfo.callLegId);
          this.setDatas();
        }, 3000);
      } else {
        clearInterval(this.timer);
      }

    }
  },
  mounted () {
    this.loading = false;
  },
  methods: {
    close () {
      this.closeDialog('detail');
    },
    secondsToTimeString (duration) {
      return Util.secondsToTimeString(Number(duration));
    },
    setDatas () {
      // Rx Tx Data Setting
      this.rxTxItems[0].datas[0].value = this.attendeeDetailInfo.status.rxAudio.packetLossPercentage;
      this.rxTxItems[0].datas[1].value = this.attendeeDetailInfo.status.rxAudio.jitter;
      this.rxTxItems[0].datas[2].value = this.attendeeDetailInfo.status.rxAudio.bitRate;

      this.rxTxItems[1].datas[0].value = this.attendeeDetailInfo.status.txAudio.packetLossPercentage;
      this.rxTxItems[1].datas[1].value = this.attendeeDetailInfo.status.txAudio.jitter;
      this.rxTxItems[1].datas[2].value = this.attendeeDetailInfo.status.txAudio.bitRate;
      this.rxTxItems[1].datas[3].value = this.attendeeDetailInfo.status.txAudio.roundTripTime;

      this.rxTxItems[2].datas[0].value = this.attendeeDetailInfo.status.rxVideo.packetLossPercentage;
      this.rxTxItems[2].datas[1].value = this.attendeeDetailInfo.status.rxVideo.jitter;
      this.rxTxItems[2].datas[2].value = this.attendeeDetailInfo.status.rxVideo.bitRate;

      this.rxTxItems[3].datas[0].value = this.attendeeDetailInfo.status.txVideo.packetLossPercentage;
      this.rxTxItems[3].datas[1].value = this.attendeeDetailInfo.status.txVideo.jitter;
      this.rxTxItems[3].datas[2].value = this.attendeeDetailInfo.status.txVideo.bitRate;
      this.rxTxItems[3].datas[3].value = this.attendeeDetailInfo.status.txVideo.width;
      this.rxTxItems[3].datas[4].value = this.attendeeDetailInfo.status.txVideo.height;
      this.rxTxItems[3].datas[5].value = this.attendeeDetailInfo.status.txVideo.frameRate;
    }
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/popup/MeetingAttendeeDetailDialog.vue